import { defineSlotRecipe } from '@chakra-ui/react';

export const messageBoxSlotRecipe = defineSlotRecipe({
    slots: ['root', 'iconContainer', 'content', 'title', 'message'],
    base: {
        root: {
            overflow: 'hidden',
        },
        iconContainer: {
            alignItems: 'center',
        },
        content: {},
        title: {
            fontWeight: 'bold',
            mb: { base: 1, md: 2 },
        },
        message: {},
    },
    variants: {
        variant: {
            info: {
                iconContainer: {
                    bg: 'secondary.600',
                },
                title: {
                    color: 'secondary.600',
                },
            },
            warning: {},
            error: {},
        },
        size: {
            sm: {},
            md: {},
            lg: {
                root: {
                    py: 4,
                    pr: 4,
                    borderRadius: 'xl',
                },
                iconContainer: {
                    px: 4,
                    my: -4,
                },
                title: {
                    fontSize: {
                        base: 'md',
                        md: 'lg',
                    },
                    lineHeight: { base: '20px', md: '24px' },
                },
                message: {
                    fontSize: {
                        base: 'sm',
                        md: 'md',
                    },
                    lineHeight: '20px',
                },
            },
        },
    },
    defaultVariants: {
        variant: 'info',
        size: 'lg',
    },
});
